const projectsData = [
    {
      title: "CipherGenix AI Platform",
      description: "Distributed AI cybersecurity platform with real-time threat detection, secure Stripe payments, and OAuth2 authentication.",
      projectLink: "#",
      codeLink: "https://github.com/sphesihlemhlongo",
      category: "AI/ML",
      buttonStyles: {
        projectButton: { backgroundColor: "#3182ce", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
        codeButton: { backgroundColor: "#2d3748", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
      },
    },
    {
      title: "NASA Exoplanet Discovery",
      description: "AI-powered system using Kepler/TESS data to classify exoplanets. Winner at NASA Space Apps Challenge (Roodepoort).",
      projectLink: "#",
      codeLink: "https://github.com/sphesihlemhlongo",
      category: "AI/ML",
      buttonStyles: {
        projectButton: { backgroundColor: "#3182ce", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
        codeButton: { backgroundColor: "#2d3748", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
      },
    },
    {
      title: "Guardrail Sentinel",
      description: "Automated AI-security audit platform detecting prompt injection and data leakage with PDF reporting.",
      projectLink: "#",
      codeLink: "https://github.com/sphesihlemhlongo",
      category: "AI/ML",
      buttonStyles: {
        projectButton: { backgroundColor: "#3182ce", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
        codeButton: { backgroundColor: "#2d3748", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
      },
    },
    {
      title: "JobIQ Interview AI",
      description: "AI-driven interview simulation app with LLM integration and Slack workflows. Microsoft Hackathon Project.",
      projectLink: "#",
      codeLink: "https://github.com/sphesihlemhlongo",
      category: "AI/ML",
      buttonStyles: {
        projectButton: { backgroundColor: "#3182ce", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
        codeButton: { backgroundColor: "#2d3748", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
      },
    },
    {
      title: "Lead Conversion AI",
      description: "ML model predicting automotive sales leads using XGBoost/LightGBM. Top 8 in Motus & Renault Hackathon.",
      projectLink: "#",
      codeLink: "https://github.com/sphesihlemhlongo",
      category: "AI/ML",
      buttonStyles: {
        projectButton: { backgroundColor: "#3182ce", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
        codeButton: { backgroundColor: "#2d3748", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
      },
    },
    {
      title: "AI Security Chatbot",
      description: "Real-time security query chatbot built with FastAPI, React, and Google Gemini, deployed on Railway/Netlify.",
      projectLink: "#",
      codeLink: "https://github.com/sphesihlemhlongo",
      category: "AI/ML",
      buttonStyles: {
        projectButton: { backgroundColor: "#3182ce", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
        codeButton: { backgroundColor: "#2d3748", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
      },
    },
    {
      title: "Code Clinics",
      description: "Full-stack mentor-student scheduling platform improving accessibility to coding guidance.",
      projectLink: "#",
      codeLink: "https://github.com/sphesihlemhlongo",
      category: "Full Stack",
      buttonStyles: {
        projectButton: { backgroundColor: "#3182ce", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
        codeButton: { backgroundColor: "#2d3748", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
      },
    },
    {
      title: "Robot Worlds",
      description: "Multiplayer strategy game where players control robots to eliminate opponents. Built with Java & Python.",
      projectLink: "#",
      codeLink: "https://github.com/sphesihlemhlongo",
      category: "Game Dev",
      buttonStyles: {
        projectButton: { backgroundColor: "#3182ce", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
        codeButton: { backgroundColor: "#2d3748", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
      },
    },
    {
      title: "Dreamers Club Website",
      description: "A business Website created with Jekyll",
      projectLink: "https://dreamersclub.netlify.app/",
      codeLink: "https://github.com/sphesihlemhlongo/dreamersclub-site",
      category: "Full Stack",
      buttonStyles: {
        projectButton: { backgroundColor: "#3182ce", padding: "10px 10px", borderRadius: "17px", userSelect: "none" },
        codeButton: { backgroundColor: "#2d3748", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
      },
    },
    {
      title: "Verify Health Claim",
      description: "Verify Health Claims made by Health influencers",
      projectLink: "https://verifyhealthclaim.netlify.app/",
      codeLink: "https://github.com/sphesihlemhlongo/easy-health.ai",
      category: "AI/ML",
      buttonStyles: {
        projectButton: { backgroundColor: "#3182ce", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
        codeButton: { backgroundColor: "#4F6180FF", padding: "10px 20px", borderRadius: "17px", userSelect: "none" },
      },
    },
  ];
  
  export default projectsData;
  